module.exports = __webpack_public_path__ + "static/media/img-goal-4.5659cdcb.jpg";